/**
 * Custom hook to get the current user's timezone
 */
import { useAuth } from '../context/AuthContext';

export const useUserTimezone = (): string => {
  const { user } = useAuth();

  // Return user's timezone or default to Asia/Jerusalem
  return user?.timezone || 'Asia/Jerusalem';
};
